<div class="stock-item-rule-enable-container no-select">

  <div class="widget-div">

    @if (canEnableItemRuleBeViewed) {
      <app-shared-widget-container-component>
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canEnableItemRuleBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canEnableItemRuleBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>Enable Item Stock Rule</div>
          <app-display-icon
            [tooltip]="tooltips.enableStockItem"
            [icon]="icons.infoSlabCircleOutline"
            [colour]="iconColours.secondary">
          </app-display-icon>
        </div>
        <div block>
          <form [formGroup]="formEnableItemRule">

            @if (formEnableItemRule?.controls['descPrefix']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <div class="label-with-icon">
                    <label for="descPrefix">Description Prefixes (remove)</label>
                    <div class="spacer"></div>
                    <app-display-icon
                      [tooltip]="tooltips.enableStockItemDescPrefixRemove"
                      [icon]="icons.infoSlabCircleOutline"
                      [colour]="iconColours.secondary">
                    </app-display-icon>
                  </div>
                  <app-shared-custom-select
                    id="descPrefix"
                    (selectionChange)="onPrefixChange($event)"
                    [allowAddNew]="true"
                    [allowMultiple]="true"
                    [allowSelectAll]="true"
                    [floatDropdown]="true"
                    [placeholder]="'Select prefixes...'"
                    [searchPlaceholder]="'Search or add prefix...'"
                    [selected]="descPrefixSelected()"
                    [setOptions]="getPrefixOptions()"
                    [showChips]="false"
                    [showSearchBar]="true">
                  </app-shared-custom-select>
                </div>
              </div>
            }

            @if (formEnableItemRule?.controls['descSuffix']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <div class="label-with-icon">
                    <label for="descSuffix">Description Suffixes (remove)</label>
                    <div class="spacer"></div>
                    <app-display-icon
                      [tooltip]="tooltips.enableStockItemDescSuffixRemove"
                      [icon]="icons.infoSlabCircleOutline"
                      [colour]="iconColours.secondary">
                    </app-display-icon>
                  </div>
                  <app-shared-custom-select
                    id="descSuffix"
                    (selectionChange)="onSuffixChange($event)"
                    [allowAddNew]="true"
                    [allowMultiple]="true"
                    [allowSelectAll]="true"
                    [floatDropdown]="true"
                    [placeholder]="'Select suffixes...'"
                    [searchPlaceholder]="'Search or add suffix...'"
                    [selected]="descSuffixSelected()"
                    [setOptions]="getSuffixOptions()"
                    [showChips]="false"
                    [showSearchBar]="true">
                  </app-shared-custom-select>
                </div>
              </div>
            }

            @if (formEnableItemRule?.controls['lineColour']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="lineColour">Line Colour</label>
                  <app-shared-custom-select
                    id="lineColour"
                    (selectionChange)="onLineColourChange($event)"
                    [allowMultiple]="false"
                    [allowSelectAll]="false"
                    [autoSubmitOnSelect]="true"
                    [floatDropdown]="true"
                    [placeholder]="'Select line colour...'"
                    [selected]="['lc-' + formEnableItemRule?.controls['lineColour']?.value?.toString()]"
                    [setOptions]="getLineColourOptions(formEnableItemRule?.controls['lineColour']?.value)"
                    [showActionButtons]="false"
                    [showChips]="false">
                  </app-shared-custom-select>
                </div>
              </div>
            }

            @if (formEnableItemRule?.controls['onHoldCode']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="onHoldCode">On Hold Code</label>
                  <app-shared-custom-select
                    id="onHoldCode"
                    (selectionChange)="onHoldCodeChange($event)"
                    [allowMultiple]="true"
                    [allowSelectAll]="true"
                    [floatDropdown]="true"
                    [placeholder]="'Select on hold codes...'"
                    [searchPlaceholder]="'Search on hold codes...'"
                    [selected]="onHoldCodeSelected()"
                    [setOptions]="getOnHoldCodeOptions(onHoldCodeSelected())"
                    [showChips]="false"
                    [showSearchBar]="true">
                  </app-shared-custom-select>
                </div>
              </div>
            }

          </form>
        </div>
        <div actions class="widget-actions">
          @if (hasEnableItemRuleBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canEnableItemRuleBeEdited === false"
              (click)="onRevertForm('enableItemRule')">
              <app-display-icon
                [colour]="canEnableItemRuleBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canEnableItemRuleBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isEnableItemRuleSubmitDisabled"
              (click)="onSubmitForm('enableItemRule')">
              <app-display-icon
                [colour]="isEnableItemRuleSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
        </div>
      </app-shared-widget-container-component>
    }

  </div>

  <div class="ups-container-action-bar widget-actions">
    @if (hasEnableItemRuleErrors?.length > 0) {
      @for (field of hasEnableItemRuleErrors; track $index) {
        <button
          type="button"
          class="error-button">
          <app-display-icon
            [colour]="iconColours.red"
            [tooltip]="field?.error"
            [icon]="icons.alertRhombusOutline">
          </app-display-icon>
        </button>
      }
    }
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onRevertForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.undoAllChanges"
          [icon]="icons.undo">
        </app-display-icon>
        Undo Changes
      </button>
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onSubmitForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.saveAllChanges"
          [icon]="icons.contentSaveOutline">
        </app-display-icon>
        Save All
      </button>
  </div>

</div>
